import { render } from "./QhlsFinalExamCenterMgmt.vue?vue&type=template&id=3bd711a4&scoped=true"
import script from "./QhlsFinalExamCenterMgmt.vue?vue&type=script&lang=js"
export * from "./QhlsFinalExamCenterMgmt.vue?vue&type=script&lang=js"

import "./QhlsFinalExamCenterMgmt.vue?vue&type=style&index=0&id=3bd711a4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd711a4"]])

export default __exports__